// Single global narration channel — guarantees only ONE spoken answer plays at
// a time across Ask ERIO (FAB), the Intelligence NLQ bar, and the AI briefing.
// Starting any narration stops whatever was previously playing.

let current = null; // { el, onForceStop }

export function startNarration(el, onForceStop) {
  if (current && current.el !== el) {
    try { current.el.pause(); } catch { /* noop */ }
    const cb = current.onForceStop;
    current = null;
    if (cb) cb();
  }
  current = { el, onForceStop };
}

// Natural end / local stop — clears without firing the force-stop callback.
export function endNarration(el) {
  if (current && current.el === el) current = null;
}

// Force-stop whatever is playing (e.g. user closes a panel).
export function stopNarration() {
  if (current) {
    try { current.el.pause(); } catch { /* noop */ }
    const cb = current.onForceStop;
    current = null;
    if (cb) cb();
  }
}
